<template><div class="unit-vpn-logs">
  <modal-dialog v-if="tfl" @close="close">
    <template v-if="tfl.loaded">
      Downloaded {{ Math.round(tfl.loaded / 1024) }}
      KiB<template v-if="tfl.total">
        of {{ Math.round(tfl.total / 1024) }} KiB
        ({{ Math.round(tfl.loaded * 100 / tfl.total) }}%)</template>.
    </template>
    <template v-else-if="tfl.filename">
      <p>Finished downloading fault log <b>{{ tfl.filename }}</b>.</p>
      <button style="float:right" @click="close">Close</button>
    </template>
    <template v-else>
      {{ tfl }}
    </template>
  </modal-dialog>
  <modal-dialog v-if="tdr" @close="close">
    <template v-if="tdr.loaded">
      Download {{ Math.round(tdr.loaded / 1024) }}
      KiB<template v-if="tdr.total">
        of {{ Math.round(tdr.total / 1024) }} KiB
        ({{ Math.round(tdr.loaded * 100 / tdr.total) }}%)</template>.
    </template>
    <template v-else-if="tdr.filename">
      <p>Finished downloading data recorder log <b>{{ tdr.filename }}</b>.</p>
      <button style="float:right" @click="close">Close</button>
    </template>
    <template v-else>
      {{ tdr }}
    </template>
  </modal-dialog>
  Select an option to download the latest available log data directly from {{ unit.name }}.
  These downloads are equivalent to the downloads you would get by visiting the unit in person and
  capturing logs using TECU-PC and a serial cable.
  <ul><li>
  <button class="download" @click="getFaultLog">Download Fault Log</button>
  </li><li v-if="info.headers.indexOf('COMMON_RECORDER')>=0">
  <button class="download" @click="getRecorderLog">Download Recorder Log</button>
  </li></ul>
</div></template>
<script>
import moment from 'moment'
import ModalDialog from '../ModalDialog'
export default {
  name: 'unit-vpn-logs',
  props: ['api','info'],
  components: { ModalDialog },
  data() {
    return {
      tfl: null,
      tdr: null,
    }
  },
  computed: {
    id() { return this.$store.state.selectedUnit },
    unit() { return this.$store.state.units[this.id] },
  },
  methods: {
    close() {
      this.tfl = null
      this.tdr = null
      this.api.cancel()
    },
    getFaultLog() {
      this.tfl = 'Starting fault log download ...'
      let fn = `t${moment().format('YYYYMMDDhhmmss')}.tfl`
      this.api.getFaultLog({
        partial: false,
        saveAs: fn,
        onDownloadProgress: e => { if (this.tfl) { this.tfl = e } },
      })
        .then(buf => { if (this.tfl) { this.tfl = buf; this.tfl.filename = fn } })
        .catch(e => { if (this.tfl) { this.tfl = e; this.tfl.error = true } })
    },
    getRecorderLog() {
      this.tdr = 'Starting data recorder log download ...'
      let fn = `t${moment().format('YYYYMMDDhhmmss')}.tdr`
      this.api.getRecorderLog({
        partial: false,
        saveAs: fn,
        onDownloadProgress: e => { if (this.tdr) { this.tdr = e } },
      })
        .then(buf => { if (this.tdr) { this.tdr = buf; this.tdr.filename = fn } })
        .catch(e => { if (this.tdr) { this.tdr = e; this.tdr.error = true } })
    },
  },
}
</script>
<style lang="scss" scoped>
.unit-vpn-logs {
  .download {
    margin: 0 0 10px 0;
  }
}
</style>
